export default __webpack_public_path__ + "static/media/loading.757857ce.gif";